import React, { Component } from "react";
import { Button, PageHeader, Panel, Row, Col } from "react-bootstrap";
import { invokeApig }              from '../libs/awsLib';
import { FontAwesomeIcon }         from '@fortawesome/react-fontawesome'
import RenderLander                from "../components/utils/RenderLander";
import ModalAddReminder            from "../components/modal/ModalAddReminder";
import SideNavReminderList         from "../components/utils/SideNavReminderList";
import { Colors }                  from "../utils/Colors";

import { invokeGetDashboardAllMemberPrograms } from "../utils/AwsInvoke";
import DatagridTable                           from "../components/dashboard/DatagridTable";
import "../css/Home.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
          isLoading: true,
          showModalAddReminder: false,
        };
    }

    componentDidMount() {
        console.log("dashboard componentDidMount");
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            this.renderDashboardList();
        } catch (e) {
            alert("Dashboard error: " + e);
        }
    }
    async renderDashboardList() {

        var user_id = this.props.globalUserId;
        var company_id =
        this.setState({ pageOverlay: "inline"})

        var results = await invokeGetDashboardAllMemberPrograms();

        for(var key in results) {
//            console.log("key: " + key);
//            console.log("results: " + results[key]);
        }
        if(results.status) {
            this.setState({
                days_left_on_program:        results.athlete_days_left_on_program,
                athlete_recent_highest_1rm:  results.athlete_recent_highest_1rm,
                athlete_completed_workouts:  results.athlete_completed_workouts,
                athlete_completed_programs:  results.athlete_completed_programs,
                athletes_newly_created:      results.athletes_newly_created,
                athlete_newly_created_programs:  results.athlete_newly_created_programs,
                athlete_newly_created_templates: results.athlete_recently_created_templates,
                athlete_recent_inactivity:       results.athlete_inactivity
            });
        }
    }


    showModalAddReminder () {
        this.setState({
            showModalAddReminder: true
        })
    }


    gotoScreen = (url) => {
        this.props.history.push(url);
    }

    renderHome() {
        //var image = "../images/logos/logo_green_ts.png"

        return (
          <div className="programs">
            <PageHeader>
                    <span className="glyphicon glyphicon-dashboard" style={{ position:"relative", top:5, fontSize: '1em', color: Colors.primary_color, paddingRight:"16px" }}/>
                    Dashboard
                    { /*}<span className="">
                        <Button bsStyle   = "default"
                                style     = {{backgroundColor: Colors.dark_gray, color:"#fff"}}
                                className = "btnAddReminderPosition pull-right"
                                onClick   = {() => this.showModalAddReminder()}
                         >

                            <FontAwesomeIcon icon="bell" style={{position:"relative", top:2, left: 0, color:"#fff"}} className="modalBasicsTitleIcon" /> &nbsp; Add Reminder
                         </Button>
                         <Button bsStyle   = "default"
                                 style     = {{backgroundColor: Colors.medium_gray, width:60, color:"#fff"}}
                                 className = "btnListremindersPosition pull-right"
                                 onClick   = {() => this.showModalAddReminder()}
                          >

                             <FontAwesomeIcon icon="plus" style={{position:"relative", top:2, left: 0, color:"#fff"}} className="modalBasicsTitleIcon" />
                          </Button>
                    </span>

                    <SideNavReminderList
                    />*/ }
            </PageHeader>

            { /*-------------------------------  ROW 1  ----------------------------------*/ }
            <Row className="grid">
                <Col xs={12} sm={12} md={12}>
                    <span href={'/exercise/listAll/&'}
                          onClick={this.handleProgramClick}
                          className="homeMainBox3"
                    >
                        <div className="datagridTableHeader">

                             <FontAwesomeIcon icon="calendar-day"
                                              className="modalBasicsTitleIcon"
                                              style={{ position:"relative", top:0, left: -7, color: Colors.dark_gray}}/>
                            <b>DAYS LEFT ON PROGRAM</b>
                        </div>
                        <span>
                                <DatagridTable screen = "days_left_on_program"
                                               data   = {this.state.days_left_on_program}
                                               gotoScreen = {this.gotoScreen}
                                               height = "223"
                                               bgColor = "#000"
                                               width  = "100%" />
                        </span>
                    </span>
                </Col>
                  <Col xs={12} sm={12} md={12}>
                      <span className="homeMainBoxSpacer"></span>
                  </Col>

            { /*-------------------------------      ROW 2       ---------------------------------*/ }
            { /*-------------------------------  ROW 2 - BOX 1  ----------------------------------*/ }
                  <Col xs={12} sm={6} md={6}>
                        <span href={'/exercise/listAll/&'}
                              onClick={this.handleProgramClick}
                              className="homeMainBox3"
                        >
                            <div className="datagridTableHeader">
                                  <FontAwesomeIcon icon="running"
                                                   className="modalBasicsTitleIco"
                                                   style={{ position:"relative", top:1, left: -7, fontSize:23, color: Colors.dark_gray}}/>
                                  <b>COMPLETED WORKOUTS</b>
                            </div>
                            <span>
                                    <DatagridTable screen = "completed_workouts"
                                                   data   = {this.state.athlete_completed_workouts}
                                                   height = "223"
                                                   width  = "100%" />
                            </span>
                        </span>
                        <br/><br/>
                   </Col>
             { /*-------------------------------  ROW 2 - BOX 2  ----------------------------------*/ }
                  <Col xs={12} sm={6} md={6}>
                        <span href={'/exercise/listAll/&'}
                              onClick={this.handleProgramClick}
                              className="homeMainBox3"
                        >
                            <div className="datagridTableHeader">
                                <FontAwesomeIcon icon="dumbbell"
                                                 className="modalBasicsTitleIcon"
                                                 style={{ position:"relative", top:1, left: -7, color: Colors.dark_gray}}/>
                                <b>COMPLETED PROGRAMS</b>
                            </div>
                            <span>
                                    <DatagridTable screen = "completed_programs"
                                                   data   = {this.state.athlete_completed_programs}
                                                   height = "223"
                                                   width  = "100%" />
                            </span>
                        </span>
                        <br/><br/>
                  </Col>
              { /*-------------------------------      ROW 3       ---------------------------------*/ }
              { /*-------------------------------  ROW 3 - BOX 1  ----------------------------------*/ }

                  <Col xs={12} sm={6} md={6}>
                      <span href={'/exercise/listAll/&'}
                            onClick={this.handleProgramClick}
                            className="homeMainBox3"
                      >
                          <div className="datagridTableHeader">

                              <FontAwesomeIcon icon="clock"
                                               className="modalBasicsTitleIcon"
                                               style={{ position:"relative", top:2, left: -7, color: Colors.dark_gray}}/>
                              <b>MEMBER INACTIVITY</b>
                          </div>
                          <span>
                                  <DatagridTable screen = "athlete_inactivity"
                                                 data   = {this.state.athlete_recent_inactivity}
                                                 height = "223"
                                                 width  = "100%" />
                          </span>
                      </span>
                      <br/><br/>
                  </Col>
               { /*-------------------------------  ROW 3 - BOX 2  ----------------------------------*/ }
                   <Col xs={12} sm={6} md={6}>
                       <span href={'/exercise/listAll/&'}
                             onClick={this.handleProgramClick}
                             className="homeMainBox3"
                       >
                           <div className="datagridTableHeader">

                             <FontAwesomeIcon icon="tasks"
                                              className="modalBasicsTitleIcon"
                                              style={{ position:"relative", top:2, left: -7, color: Colors.dark_gray}}/>
                               <b>NEW PROGRAMS FOR MEMBERS</b>
                           </div>
                           <span style={{textDecoration: "none"}}>
                                   <DatagridTable screen = "new_programs_created"
                                                  data   = {this.state.athlete_newly_created_programs}
                                                  height = "223"
                                                  width  = "100%" />
                           </span>
                       </span>
                       <br/><br/>
                   </Col>
                   { /*-------------------------------      ROW 4       ---------------------------------*/ }
                   { /*-------------------------------  ROW 4 - BOX 1  ----------------------------------*/ }
                   <Col xs={12} sm={12} md={12}>
                       <span href={'/exercise/listAll/&'}
                             onClick={this.handleProgramClick}
                             className="homeMainBox3"
                       >
                           <div className="datagridTableHeader">

                               <FontAwesomeIcon icon="trophy"
                                                className="modalBasicsTitleIcon"
                                                style={{ position:"relative", top:0, left: -7, color: Colors.dark_gray}}/>
                               <b>ATHLETE HITS NEW PERSONAL RECORD</b>
                           </div>
                           <span>
                                   <DatagridTable screen = "athlete_highest_1rm"
                                                  data   = {this.state.athlete_recent_highest_1rm}
                                                  height = "223"
                                                  width  = "100%" />
                           </span>
                       </span>
                       <br/><br/>
                   </Col>

                    { /*-------------------------------  ROW 4 - BOX 2  ----------------------------------*/ }


                    { /*-------------------------------      ROW 5       ---------------------------------*/ }
                    { /*-------------------------------  ROW 5 - BOX 1  ----------------------------------*/ }
                    <Col xs={12} sm={6} md={6}>
                        <span href={'/exercise/listAll/&'}
                              onClick={this.handleProgramClick}
                              className="homeMainBox3"
                        >
                            <div className="datagridTableHeader">
                                <FontAwesomeIcon icon="user-circle"
                                                 className="modalBasicsTitleIcon"
                                                 style={{ position:"relative", top:2, left: -7, color: Colors.dark_gray}}/>
                                <b>NEW MEMBERS</b>
                            </div>
                            <span style={{textDecoration: "none"}}>
                                    <DatagridTable screen = "new_clients_created"
                                                   data   = {this.state.athletes_newly_created}
                                                   height = "223"
                                                   width  = "100%" />
                            </span>
                        </span>
                        <br/><br/>
                    </Col>

                    <Col xs={12} sm={6} md={6}>
                        <span href={'/exercise/listAll/&'}
                              onClick={this.handleProgramClick}
                              className="homeMainBox3"
                        >
                            <div className="datagridTableHeader">

                                <FontAwesomeIcon icon="file-alt"
                                                 className="modalBasicsTitleIcon"
                                                 style={{ position:"relative", top:2, left: -7, color: Colors.dark_gray}}/>
                                <b>NEW PROGRAM TEMPLATES</b>
                            </div>
                            <span style={{textDecoration: "none"}}>
                                    <DatagridTable screen = "new_templates_created"
                                                   data   = {this.state.athlete_newly_created_templates}
                                                   height = "223"
                                                   width  = "100%" />
                            </span>
                        </span>
                        <br/><br/>
                    </Col>
            </Row>
          </div>
        );
    }

    render() {
        let closeModalAddReminder = () => this.setState({ showModalAddReminder: false }); //close simple modal window

        return (
              <div className="Home">
                {this.props.isAuthenticated ? this.renderHome() : <RenderLander />}

                {this.state.showModalAddReminder ?
                    <ModalAddReminder
                        show={this.state.showModalAddReminder}
                        onHide={closeModalAddReminder}
                    />
                : null}
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Dashboard.js